import { cn } from "~/common/cn"
import { balanceText } from "~/common/text-utils"
import { AppText } from "~/ui/app-text"
import { UserAvatar } from "~/ui/user-avatar"

interface HostPillProps {
  member: {
    avatarUrl?: string | null
    displayOrUsername?: string | null
    verifiedAccount?: boolean | null
  }
  variant?: "horizontal" | "stacked" | "compact"
}

export const HostPill = ({ member, variant = "horizontal" }: HostPillProps) => {
  const displayName = member.displayOrUsername ?? ""

  if (variant === "compact") {
    return (
      <div className="flex shrink-0 flex-row items-center rounded-full bg-opacity-black px-1.5 py-0.5">
        <UserAvatar
          avatarUrl={member.avatarUrl}
          displayName={displayName}
          verifiedAccount={member.verifiedAccount ?? undefined}
          size={"xsm-sm"}
        />
        <div className="min-w-0 flex-1 px-1.5">
          <AppText variant="hairline-2" className="max-w-[28ch] truncate text-left text-base-white">
            {displayName}
          </AppText>
        </div>
      </div>
    )
  }

  if (variant === "stacked") {
    const [firstLine, secondLine] = balanceText(displayName, 20)
    return (
      <div className={cn("flex shrink-0 flex-col items-center gap-2 p-1")}>
        <UserAvatar
          avatarUrl={member.avatarUrl}
          displayName={displayName}
          verifiedAccount={member.verifiedAccount ?? undefined}
          size={"md"}
          imgClassName="border-0"
          className="border-0"
        />
        <AppText
          variant="hairline-2"
          className="line-clamp-2 max-w-[100px] text-center font-bold normal-case leading-[16px] text-base-white"
        >
          {secondLine ? (
            <>
              {firstLine}
              <br />
              {secondLine}
            </>
          ) : (
            firstLine
          )}
        </AppText>
      </div>
    )
  }

  const [firstLine, secondLine] = balanceText(displayName, 12)
  return (
    <div className="flex shrink-0 flex-row items-center rounded-full bg-opacity-black px-2 py-1 md:m-1">
      <UserAvatar
        avatarUrl={member.avatarUrl}
        displayName={displayName}
        verifiedAccount={member.verifiedAccount ?? undefined}
        size={"shareCard"}
      />
      <div className={cn("px-2 py-1")}>
        <AppText variant="hairline-2" className="line-clamp-2 w-full text-left text-base-white">
          {secondLine ? (
            <>
              {firstLine}
              <br />
              {secondLine}
            </>
          ) : (
            firstLine
          )}
        </AppText>
      </div>
    </div>
  )
}
